import { ref } from 'vue'

export function useHorizontalScroll() {
  // Refs for all scroll containers
  const scrollContainers = ref([])

  // States for showing/hiding arrows
  const leftArrowsVisible = ref([])
  const rightArrowsVisible = ref([])

  function scrollLeft(index) {
    const container = scrollContainers.value[index]
    if (!container) return
    container.scrollBy({ left: -400, behavior: 'smooth' })
  }

  function scrollRight(index) {
    const container = scrollContainers.value[index]
    if (!container) return
    container.scrollBy({ left: 400, behavior: 'smooth' })
  }

  function onScroll(index) {
    checkArrowVisibility(index)
  }

  function checkArrowVisibility(index) {
    const container = scrollContainers.value[index]
    if (!container) return

    // If the scroll is at the beginning (scrollLeft === 0), hide the left arrow
    leftArrowsVisible.value[index] = container.scrollLeft > 0

    // If the scroll is near the end
    const scrollRightMax = container.scrollWidth - container.clientWidth
    rightArrowsVisible.value[index] = container.scrollLeft < (scrollRightMax - 1)
  }

  // Check visibility for ALL containers
  function checkAllArrowsVisibility(nonEmptyCategories) {
    nonEmptyCategories.forEach((_, idx) => {
      checkArrowVisibility(idx)
    })
  }

  function showLeftArrow(index) {
    return leftArrowsVisible.value[index]
  }

  function showRightArrow(index) {
    return rightArrowsVisible.value[index]
  }

  return {
    scrollContainers,
    scrollLeft,
    scrollRight,
    onScroll,
    checkAllArrowsVisibility,
    showLeftArrow,
    showRightArrow,
  }
}
